import { OtpInput } from "reactjs-otp-input";
import { useState } from "react";

const OTPComponent = ({ handleEnterOTP }) => {
  const [otp, setOtp] = useState("");

  return (
    <OtpInput
      value={otp}
      onChange={(value) => {
        const numericValue = value.replace(/\D/g, "");
        setOtp(numericValue);
        handleEnterOTP(numericValue);
      }}
      numInputs={6}
      separator={<span>-</span>}
      isInputNum={true}
      className="otpinputStyle"
      shouldAutoFocus={true}
      renderInput={(props) => (
        <input
          {...props}
          type="number"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="one-time-code"
          onKeyDown={(event) => {
            if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
              event.preventDefault();
            }
          }}
        />
      )}
    />
  );
};

export default OTPComponent;
